import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';

import { QUOTE_KEYS } from './createQuote.const';
import { ICreateQuoteSliceInitialState } from './createQuote.interface';

const initialState: ICreateQuoteSliceInitialState = {
    isCreateLoading: false,
    error: null,
    data: {
        currentStep: QUOTE_KEYS.QUOTE_DETAILS,
        completedSteps: [],
        createQuoteData: null,
    },
    isCreateQuoteModal: false,
    isDivisionShow: false,
};

export const CreateQuoteSlice = createSlice({
    name: 'CreateQuote',
    initialState,
    reducers: {
        resetCreateQuoteData: () => initialState,
        setIsCreateQuoteModal: (state, { payload }) => {
            state.isCreateQuoteModal = payload;
        },
        setCreateQuoteStep: (state, { payload }) => {
            state.data.currentStep = payload;
        },
        setCompletedStep: (state, { payload }) => {
            // Support both array (for loading from API/draft) and string (for adding individual steps)
            if (Array.isArray(payload)) {
                state.data.completedSteps = payload;
            } else {
                if (!state.data.completedSteps) {
                    state.data.completedSteps = [];
                }

                if (!state.data.completedSteps.includes(payload)) {
                    state.data.completedSteps.push(payload);
                }
            }
        },
        setCreateQuoteData: (state, { payload }) => {
            state.data.createQuoteData = {
                ...state.data.createQuoteData,
                ...payload.data,
            };
        },
        setIsDivisionShow: (state, { payload }) => {
            state.isDivisionShow = payload;
        },
        setIsCreateLoading: (state, { payload }) => {
            state.isCreateLoading = payload;
        },
    },
});

export const { setCreateQuoteStep, setIsCreateQuoteModal, setCreateQuoteData, resetCreateQuoteData, setIsDivisionShow, setCompletedStep, setIsCreateLoading } = CreateQuoteSlice.actions;

export const createQuoteCurrentStep = (state: RootState): any => state.CreateQuote.data?.currentStep;

export const completedSteps = (state: RootState): string[] => state.CreateQuote.data?.completedSteps || [];

export const isCreateQuoteModal = (state: RootState): boolean => state.CreateQuote.isCreateQuoteModal;

export const customerDetails = (state: RootState): any => state.CreateQuote.data?.createQuoteData?.customerDetails || null;

export const hubSpotCustomerDetails = (state: RootState): any => state.CreateQuote.data?.createQuoteData?.hubSpotCustomerDetails || null;

export const divisionId = (state: RootState): number | null => state.CreateQuote.data?.createQuoteData?.divisionId || null;

export const customerBillingAccountId = (state: RootState): number | null => state.CreateQuote.data?.createQuoteData?.customerBillingAccountId || null;

export const createQuoteData = (state: RootState): any => state.CreateQuote.data?.createQuoteData || null;

export const quoteDetails = (state: RootState): any => state.CreateQuote.data?.createQuoteData?.quoteDetails || null;

export const shipperConsigneeDetails = (state: RootState): any => state.CreateQuote.data?.createQuoteData?.shipperConsigneeDetails || null;

export const shipmentDetails = (state: RootState): any => state.CreateQuote.data?.createQuoteData?.shipmentDetails || null;

export const isDivisionShow = (state: RootState): boolean => state.CreateQuote.isDivisionShow;

export const dimensionsDetails = (state: RootState): any => state.CreateQuote.data?.createQuoteData?.dimensionsDetails || null;

export const isCreateLoading = (state: RootState): boolean => state.CreateQuote.isCreateLoading;

export default CreateQuoteSlice.reducer;
